import { extendTheme, withDefaultColorScheme, withDefaultSize } from '@chakra-ui/react'

import colors from './colors'
import components from './components'
import fonts from './fonts'
import semanticTokens from './semanticTokens'
import global from './global'

type PaletteColors = {
  50: string
  100: string
  200: string
  300: string
  400: string
  500: string
  600: string
  700: string
  800: string
  900: string
}

type SemanticTokens = {
  [key: string]: {
    default: string
    _dark: string
  }
}

type Fonts = {
  heading: string
  body: string
}

type Params = {
  colors: ThemeColors
}

type NewTheme = {
  colors?: ThemeColors
  styles: any
  fonts: Fonts
  components: any
  semanticTokens: {
    colors: SemanticTokens
  }
}

export type ThemeColors = {
  [key: string]: PaletteColors | string
}

function createCustomTheme(params?: Params) {
  const newTheme: NewTheme = {
    styles: {
      global,
    },
    colors: colors,
    fonts,
    components,
    semanticTokens: {
      colors: semanticTokens,
    },
  }

  if (params) newTheme.colors = { ...colors, ...params.colors }

  const customTheme = extendTheme(
    newTheme,
    withDefaultColorScheme({ colorScheme: 'primary' }),
    withDefaultSize({ size: 'sm' }),
    withDefaultSize({
      size: 'md',
      components: ['Heading'],
    })
  )

  return customTheme
}

export default createCustomTheme
